import { Link } from "react-router-dom";
import { useHubVisitor, withVisitor } from "../hubContext";

const QUOTES = [
  {
    who: "Coastal office broker (placeholder)",
    text: "The desk stayed quiet enough that my agents actually finished files. We will replace this quote with a real one after the pilot.",
  },
  {
    who: "Buyer on a first journey (placeholder)",
    text: "I was not racing anyone. The checklist asked what I already knew, then let me rest.",
  },
  {
    who: "Listing agent (placeholder)",
    text: "Seller photos stayed on the seller carpet. Client messaging did not leak into office notes.",
  },
];

export default function Testimonials() {
  const visitor = useHubVisitor();
  return (
    <article>
      <h1>Testimonials</h1>
      <p className="lead">
        Placeholder voices until offices share theirs. Nothing here is a paid endorsement or a
        performance claim.
      </p>
      <div className="card-grid">
        {QUOTES.map((item) => (
          <blockquote key={item.who} className="card">
            <p>“{item.text}”</p>
            <p className="muted">— {item.who}</p>
          </blockquote>
        ))}
      </div>
      <p>
        <Link to={withVisitor("/contact", visitor)}>Share a note</Link>
        {" · "}
        <Link to={withVisitor("/broker-pilot", visitor)}>Broker pilot</Link>
      </p>
    </article>
  );
}
